import React from "react";
import { object } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { ParagraphSection } from "./ParagraphSection";

const ParagraphSectionConnector = ({ data }) => (
	<ParagraphSection
		heading={data.heading}
		subHeading={data.subHeading}
		paragraphs={data.paragraphs}
		variant={data.variant}
		alignment={data.alignment}
		footer={data.otherDetails}
		layout={data.layout}
	/>
);

ParagraphSectionConnector.propTypes = {
	data: object.isRequired,
};

export default ParagraphSectionConnector;
export { ParagraphSectionConnector };
